"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
const radii_1 = require("../basic/radii");
const font_faces_1 = require("./font-faces");
const shadows_1 = require("../basic/shadows");
exports.map = {
    pinWrapper: {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: '6px solid',
    },
    pinContent: Object.assign({ position: 'absolute', borderRadius: radii_1.radii.default, bottom: '6px', transform: 'translate(-50%, 0)', padding: '6px 8px', cursor: 'pointer', boxShadow: shadows_1.shadows.cardShadow, color: 'white' }, font_faces_1.FONT_SIZE.SMALL),
};
//# sourceMappingURL=map.js.map